<template>
  <div class="exceptions-page">
    <!-- 动态绑定图片源，根据当前路由的 meta.exception 值选择对应的图片。 -->
    <img :src="exceptionsImages[`page${$route.meta.exception}`]" />
    <div class="back">
      <!-- 返回首页的按钮，点击时调用 back 方法并传入 'home' 参数。 -->
      <span @click="back('home')">返回首页</span>
      <!-- 返回上一页的按钮，显示倒计时时间，点击时调用 back 方法。 -->
      <span @click="back">返回上一页({{ second }})</span>
    </div>
  </div>
</template>

<script>
import page404 from "@/assets/images/page404.jpg";
import page403 from "@/assets/images/page403.jpg";
import page500 from "@/assets/images/page500.jpg";
export default {
  name: "Exceptions",
  data() {
    // data函数返回一个对象，包含以下属性
    return {
      //exceptionsImages: 一个对象，键为 page404、page403 和 page500，值为对应的图片路径
      exceptionsImages: {
        page404,
        page403,
        page500,
      },
      second: 5,
      timer: null, //用于存储定时器的引用
    };
  },
  methods: {
    // back(type): 处理返回逻辑的方法。如果 type 为 'home'，则使用 this.$router.replace 跳转到首页。否则，使用 this.$router.back 返回上一页。
    back(type) {
      if (type === "home") {
        this.$router.replace(this.$ax.config.homePath);
      } else {
        this.$router.back();
      }
    },
  },
  mounted() {
    // 在组件挂载后启动一个定时器，每秒减少 second 的值，当 second 为 0 时调用 back 方法
    this.timer = setInterval(() => {
      if (this.second === 0) this.back();
      else this.second--;
    }, 1000);
  },
  // 在组件销毁前清除定时器，防止内存泄漏
  beforeDestroy() {
    clearInterval(this.timer);
  },
};
</script>

<style lang="less" scoped>
.exceptions-page {
  text-align: center;
  .back {
    margin-top: -50px;
    color: #3853db;
    font-size: 16px;
    span {
      cursor: pointer;
      &:nth-child(1) {
        margin-right: 40px;
      }
    }
  }
}
</style>
